import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class ReturnFromInvoiceFullyPaidEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-success"}>
                        <Icon value={"check-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="invoice.analytics.events.return_fully_paid.text"
                            defaultMessage="Return {identifier} for this invoice has been fully paid for a total amount of {amount}"
                            values={{
                                identifier: <strong>{this.state.object.attributes.identifier}</strong>,
                                amount: <strong>
                                    <FormattedNumber
                                        value={this.state.object.attributes.totalAmount}
                                        style={'currency'}
                                        currency={this.state.object.attributes.currency}
                                    />
                                </strong>,
                            }}
                        />
                    </p>
                </div>
            </div>
        </div>
    }

}

export default ReturnFromInvoiceFullyPaidEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/return-from-invoice-fully-paid.component.jsx